export interface IDateListItem {
  value: number,
  label: string
}

interface IMonthObject {
  [key: string]: IDateListItem[]
}

const monthList: IMonthObject = {
  default: [
    {
      value: 0,
      label: 'Январь'
    },
    {
      value: 1,
      label: 'Февраль'
    },
    {
      value: 2,
      label: 'Март'
    },
    {
      value: 3,
      label: 'Апрель'
    },
    {
      value: 4,
      label: 'Май'
    },
    {
      value: 5,
      label: 'Июнь'
    },
    {
      value: 6,
      label: 'Июль'
    },
    {
      value: 7,
      label: 'Август'
    },
    {
      value: 8,
      label: 'Сентябрь'
    },
    {
      value: 9,
      label: 'Октябрь'
    },
    {
      value: 10,
      label: 'Ноябрь'
    },
    {
      value: 11,
      label: 'Декабрь'
    }
  ]
}

export const getYears = (): IDateListItem[] => {
  const yearsList = []
  const yearNow = new Date().getFullYear()
  for (let i = yearNow; i > yearNow - 200; i--) {
    yearsList.push({
      value: i,
      label: String(i)
    })
  }
  return yearsList
}

export const getMonths = (type: string = 'default') => {
  return monthList[type]
}

export const getDays = (year: number = 1970, month: number = 0): IDateListItem[] => {
  const daysCount = 33 - new Date(year, month, 33).getDate()
  const daysList: IDateListItem[] = []

  for (let i = 1; i <= daysCount; i++) {
    daysList.push({
      label: i < 10 ? `0${i}` : String(i),
      value: i
    })
  }
  return daysList
}
